import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';
import * as fromIts2Store from '@apps/its2/store';
import { CreateService } from '@apps/its2/models/create-service';
import { NextParams } from '@ui/misc/wizard/models';

@Component({
    selector: 'aa-create-service-summary',
    templateUrl: './create-service-summary.component.html',
    styleUrls: [
        './create-service-summary.component.scss',
        '../../request-create.scss'
    ],
    standalone: false
})
export class CreateServiceSummaryComponent implements OnInit, OnDestroy
{
    private static stepIdx: number = 4;
    private destroyator = new Subject();
    public cs: Observable<CreateService> = null;
    public isProcessing: boolean = false;
    public step2Html: string;
    public step4Html: string;
    @Output() close = new EventEmitter();

    constructor (
        translateService: TranslateService,
        private store: Store<IAuroraState>,
        private actions: Actions
    )
    {
        this.cs = this.store.select(fromIts2Store.getCreateService)
            .pipe(
                map((cs: CreateService) =>
                    new CreateService(translateService.currentLang, cs)
                )
            );
    }

    ngOnInit (): void
    {
        this.actions
            .pipe(
                ofType(fromRootStore.RootMiscStoreActions.RootWizard2StepExitRequested),
                filter((nextParams: NextParams) =>
                    nextParams.oldStepIdx === CreateServiceSummaryComponent.stepIdx
                ),
                tap((nextParams: NextParams) =>
                {
                    this.store.dispatch(
                        fromRootStore.RootMiscStoreActions.RootWizard2StepExitAccepted(nextParams)
                    );
                    this.store.dispatch(fromRootStore.RootMiscStoreActions.RootWizardStepActivated({ stepIdx: nextParams.newStepIdx }));
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }
}
